/**
 * Price Change Markers
 *
 * Updates colors and classes so that page elements can better reflect
 * the current market status at a glance.
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';

export class PriceChangeMarkers {
    getQuoteApiMarketStatus() {
        const priceChange = document.querySelector('[data-quoteapi="changeSignCSS"]');
        return priceChange ? priceChange.className : '';
    }

    getFoolQuoteMarketStatus(increaseClassName = 'positive', decreaseClassName = 'negative') {
        const change = document.querySelector('.price-change-arrow');
        if (!change) {
            return '';
        }

        const map = {
            increase: increaseClassName,
            decrease: decreaseClassName,
        };
        const changeString = change.firstElementChild.className.trim();
        return changeString in map ? map[changeString] : '';
    }

    updateRootMarketStatus(marketStatus) {
        if (marketStatus) {
            document.body.setAttribute('data-market-status', marketStatus);
        }
    }

    initArrowForFoolQuoteInfo() {
        const svgArrow = document.querySelector('.dynamic-arrow');
        const legacyArrow = document.querySelector('.price-change-arrow');
        if (svgArrow && legacyArrow) {
            const marketStatus = this.getFoolQuoteMarketStatus('up', 'down');
            if (marketStatus) {
                svgArrow.classList.add('arrow-' + marketStatus);
            }
            legacyArrow.insertAdjacentElement('beforebegin', svgArrow);
        }
    }

    addChangeClassToFoolQuoteElements() {
        const changeClass = `is-${this.getFoolQuoteMarketStatus()}`;
        const selectors = ['.price-change-dollars', '.price-change-percent'];
        $$(selectors.join(',')).forEach((el) => el.classList.add(changeClass));
    }

    /**
     * Sets an attribute on the <body> tag so it can be used throughout the entire template.
     *
     * @return {void}
     */
    initBodyMarketStatusAttribute() {
        this.updateRootMarketStatus(this.getQuoteApiMarketStatus());
        this.updateRootMarketStatus(this.getFoolQuoteMarketStatus());
    }

    init() {
        this.initBodyMarketStatusAttribute();
        this.addChangeClassToFoolQuoteElements();
        this.initArrowForFoolQuoteInfo();
    }
}
